<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="29"
       height="29"
       viewBox="0 0 29 29"
       fill="none">
    <g clip-path="url(#clip0_46287_4274)">
      <path d="M28.252 7.36132V17.3688C28.252 20.9976 26.1085 23.1739 22.4336 23.1739H13.9217L9.27731 27.3256C8.6892 27.856 8.30172 28.0899 7.80682 28.0899C7.08556 28.0899 6.65591 27.5817 6.65591 26.7925V23.1739H5.70656C2.21132 23.1739 0 21.0109 0 17.3688V7.36132C0 3.71928 2.13679 1.54297 5.81835 1.54297H22.4336C26.1085 1.54297 28.252 3.72594 28.252 7.36132ZM12.311 7.57629L9.05968 16.496C8.94384 16.8395 8.90212 17.0734 8.90212 17.2798C8.90212 17.9406 9.33308 18.3618 10.0525 18.3618C10.633 18.3618 11.0218 18.0645 11.2224 17.3415L12.0051 15.056H16.2402L17.0229 17.3415C17.2302 18.0645 17.6092 18.3618 18.203 18.3618C18.9056 18.3618 19.3432 17.9406 19.3432 17.2864C19.3432 17.0734 19.3081 16.8395 19.1856 16.496L15.9343 7.57629C15.6165 6.65808 15.0103 6.21294 14.1036 6.21294C13.216 6.21294 12.6319 6.65497 12.311 7.57629ZM15.7408 13.3037H12.5014L14.0609 8.56135H14.1843L15.7408 13.3037Z"
            :fill="color"/>
    </g>
    <defs>
      <clipPath id="clip0_46287_4274">
        <rect width="28.6133"
              height="28.0882"
              :fill="color"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
